<div class="d-flex flex-column flex-fill dx-card">
  <div class="d-flex mt-3 ms-3">
    <dx-form [formData]="filter" style="max-width: 150px">
      <dxi-form-item dataField="startDate" editorType="dxDateBox"></dxi-form-item>
      <dxi-form-item dataField="endDate" editorType="dxDateBox"></dxi-form-item>
    </dx-form>
    <div class="d-flex flex-column ms-3 mt-3">
      <button class="btn btn-secondary" (click)="toggleShowPreviousWeek()">
        {{ showPreviousWeek ? 'This Week' : 'Previous Week' }}
      </button>
      <button class="btn btn-primary mt-2" (click)="getData()">Search</button>
    </div>
  </div>
  <div class="d-flex flex-row flex-fill p-2">
    <div class="d-flex flex-column flex-fill p-1">
      <dx-data-grid
        #dataGrid
        class="flex-fill d-flex flex-column"
        height="650px"
        [dataSource]="revenueByType"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        [columnAutoWidth]="false"
        >
        <dxi-data-grid-column dataField="completed" format="shortDate" width="125"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="revenueType" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="amount" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="customer" cellTemplate="customerLinkTemplate" width="250"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="rentalId" cellTemplate="rentalLinkTemplate" caption="Rental #" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="jobId" caption="Job #" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="jobType" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="dumpsterSize" caption="Dumpster" width="125"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="billAsDumpsterSize" caption="Bill As Dumpster" width="125"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="weight" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="action" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="driver" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="salesPerson" width="90"></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>

        <div *dxTemplate="let cell of 'customerLinkTemplate'">
          @if (cell) {
            <a [routerLink]="'/customers/' + cell.data.customerId" [innerHtml]="cell.text"></a>
          }
        </div>
        <div *dxTemplate="let cell of 'rentalLinkTemplate'">
          @if (cell) {
            <a [routerLink]="'/rentals/' + cell.data.rentalId" [innerHtml]="cell.text"></a>
          }
        </div>

        <div *dxTemplate="let data of 'toolbarHeaders'">
          <h4 class="m-0">Revenue by Type</h4>
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (dataGrid) {
            <span class="me-3">
              <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
            </span>
          }
        </div>

        <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
        <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
        <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
        <dxo-data-grid-selection [mode]="'multiple'"></dxo-data-grid-selection>
        <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="revenue-by-type-grid"></dxo-data-grid-state-storing>

        <dxo-data-grid-summary>
          <dxi-data-grid-total-item
            column="amount"
            summaryType="sum"
            [displayFormat]="'{0}'"
            [valueFormat]="{ type: 'currency', precision: 2 }"
            >
          </dxi-data-grid-total-item>
          <dxi-data-grid-total-item
            column="weight"
            summaryType="sum"
            [displayFormat]="'{0}'"
            [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
            >
          </dxi-data-grid-total-item>
        </dxo-data-grid-summary>
      </dx-data-grid>
    </div>
  </div>
</div>
